import { render, staticRenderFns } from "./approvalHandover.vue?vue&type=template&id=76b07ad4&scoped=true&"
import script from "./approvalHandover.vue?vue&type=script&lang=js&"
export * from "./approvalHandover.vue?vue&type=script&lang=js&"
import style0 from "./approvalHandover.vue?vue&type=style&index=0&id=76b07ad4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b07ad4",
  null
  
)

export default component.exports